import type { RootState } from 'src/redux/store'
import { createSelector } from 'reselect'
import { getFullProductDetails } from 'src/utils/product'

export const selectInvoice = (state: RootState): Invoice.InvoiceState =>
  state['@invoice']

const createOrderItemsSelector = () =>
  createSelector(
    [
      (state) => state['@invoice'].meta.data?.storeOrder?.orderItems,
      (state) => state['@menu'].data
    ],
    (orderItems, menu) =>
      (orderItems || [])
        .filter((item) => !item.isPromotionalItem && item.quantity > 0)
        .map((item) => getFullProductDetails(menu || [], item))
  )

const createPromotionalOrderItemsSelector = () =>
  createSelector(
    [
      (state) => state['@invoice'].meta.data?.storeOrder?.orderItems,
      (state) => state['@menu'].data
    ],
    (orderItems, menu) =>
      (orderItems || [])
        .filter((item) => item.isPromotionalItem)
        .map((item) => getFullProductDetails(menu || [], item))
  )

export const selectStoreOrderItems = (state: RootState): Oms.V4.OrderItem[] =>
  createOrderItemsSelector()(state)

export const selectPromotionalOrderItems = (
  state: RootState
): Oms.V4.OrderItem[] => createPromotionalOrderItemsSelector()(state)
